
import React, {Component} from "react";

import LevelsWidget from "./widgets/levels-widget.js";

import BadgesWidget from "./widgets/badges-widget.js";

import AchievementsWidget from "./widgets/achievements-widget.js";



import "./side-section.css";


class SideSection extends Component {
    render () {
        let {start_func, progress} = this.props;
        return (
            <div className='progress_map_side_section'>
                <div className='progress_map_side_section_block steps'>
                    <LevelsWidget current_step={progress}></LevelsWidget>
                </div>
                <div className='progress_map_side_section_block badges'>
                    <BadgesWidget current_step={progress}></BadgesWidget>
                </div>
                <div className='progress_map_side_section_block achievements'>
                    <AchievementsWidget />
                </div>
                <div className='progress_map_start_button_container'>
                    <button className='progress_view_start_button' onClick={start_func}><i className='fa fa-play progress_view_start_play_icon'></i>Start</button>
                </div>
            </div>
        );
    }
}

export default SideSection;



// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/progress-map/side-section.js